import { render } from "./BarbieBarbieScreen.vue?vue&type=template&id=67f2da4f&scoped=true&ts=true&lang=pug"
import script from "./BarbieBarbieScreen.vue?vue&type=script&lang=ts"
export * from "./BarbieBarbieScreen.vue?vue&type=script&lang=ts"

import "./BarbieBarbieScreen.vue?vue&type=style&index=0&id=67f2da4f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2da4f"]])

export default __exports__